import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import ArticleFontWrapper from './write/ArticleFontWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PreviewContentContainer = styled(UIFlex).attrs({
  justify: 'center'
}).withConfig({
  displayName: "ArticleVersionPreview__PreviewContentContainer",
  componentId: "sc-535xa-0"
})(["height:100%;width:100%;overflow:auto;"]);
export default function ArticleVersionPreview(props) {
  const {
    version
  } = props;
  if (!version) {
    return null;
  }
  return /*#__PURE__*/_jsx(PreviewContentContainer, {
    children: /*#__PURE__*/_jsx(ArticleFontWrapper
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    , {
      templateSettings: props.templateSettings,
      linksColor: props.linksColor,
      children: /*#__PURE__*/_jsxs("div", {
        className: "m-top-4",
        style: {
          width: '688px'
        },
        children: [/*#__PURE__*/_jsx("div", {
          className: "article-title-text m-bottom-4",
          children: version.object.name
        }), /*#__PURE__*/_jsx("div", {
          className: "article-subtitle-text m-bottom-8",
          children: version.object.articleSummary
        }), /*#__PURE__*/_jsx("div", {
          className: "article-body",
          children: /*#__PURE__*/_jsx("div", {
            dangerouslySetInnerHTML: {
              __html: version.object.articleBody
            }
          })
        })]
      })
    })
  });
}